import ChartApi from '../../pages/desempeno-politico/ChartApi';

export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" >
        <div className="col-12">
          <div className="d-flex justify-content-center border-top-graph">
            <ChartApi />
          </div>
        </div>
      </div>
    </div>
  )
}
